import styled from "styled-components";

const IngredientsPageStyled = styled.div`

`;

export default IngredientsPageStyled;